import { ReactNode, forwardRef } from 'react';
import Slider from 'react-slick';
import cn from 'classnames';
import { SettingsTypes } from './types';
import styles from './styles.module.scss';
export type CarouselRef = InstanceType<typeof Slider>;

type CarouselProps = SettingsTypes & {
  children: ReactNode;
};

const Carousel = forwardRef<CarouselRef, CarouselProps>(({ children, className, ...props }: CarouselProps, ref) => (
  <Slider ref={ref} {...props} className={cn(styles.slickSliderReset, className)}>
    {children}
  </Slider>
));

export default Carousel;
